/** Kategoriale Farbpalette für die Line-Werte (1–15) der SWA-Visualisierung. */
export const LINE_COLORS: string[] = [
  '#2563eb', '#16a34a', '#ea580c', '#7c3aed', '#0891b2',
  '#d61f7a', '#b45309', '#0d9488', '#4f46e5', '#dc2626',
  '#65a30d', '#c026d3', '#0369a1', '#a16207', '#475569'
];

/** Farbe für Komponenten ohne Line-Zuordnung. */
export const NO_LINE_COLOR = '#c4ccd4';

/** Liefert eine stabile, deterministische Farbe für einen Line-Wert. */
export function getLineColor(line: number | null | undefined): string {
  if (line == null || line < 1) { return NO_LINE_COLOR; }
  return LINE_COLORS[(line - 1) % LINE_COLORS.length];
}
